
export class ResetPasswordModel {
    oldPassword: string;
    newPassword: string;
    confirmPassword: string;
};